export const CONNECTION_ERROR = "CONNECTION_ERROR";
export const CONNECTION_AVAILABLE = "CONNECTION_AVAILABLE";
